export default {
    to: "/dashboard/waas/",
    order: 3,
    icon: "mdi-target-account",
    title: "Beneficiary",
    disabled: false,
    value: 0,
    sublinks: [
        {
            to: "/dashboard/waas/beneficiaries/amend-details",
            order: 2,
            icon: "mdi-clipboard-edit",
            title: "Amend Details",
            disabled: false,
            value: 0,
        },
        {
            to: "/dashboard/waas/beneficiaries/wallet/top-up",
            order: 2,
            icon: "mdi-archive-arrow-up",
            title: "Top Up",
            disabled: false,
            value: 0,
        },
        {
            to: "/dashboard/waas/beneficiaries/wallet/send-to-beneficiary",
            order: 2,
            icon: "mdi-credit-card-check-outline",
            title: "Send To Beneficiary",
            disabled: false,
            value: 0,
        },
        {
            to: "/dashboard/waas/beneficiaries/wallet/mobile-money-transfer",
            order: 2,
            icon: "mdi-credit-card-multiple-outline",
            title: "Mobile Money Transfer",
            disabled: false,
            value: 0,
        },
        {
            to: "/dashboard/waas/beneficiaries/wallet/send-to-bank",
            order: 2,
            icon: "mdi-credit-card-wireless",
            title: "Bank Transfer",
            disabled: false,
            value: 0,
        },
        {
            to: "/dashboard/waas/beneficiaries/wallet/send-to-merchant",
            order: 2,
            icon: "mdi-credit-card-refund",
            title: "Send To Merchant",
            disabled: false,
            value: 0,
        },
    ]
}
